import { createResourceShortlistAssociationCacheReconciler } from 'v4/entities/associations/resource__shortlist/resource__shortlist.cache';
import { queryClient } from 'v4/migration/queryClientSingleton';

export function initMigrationCacheReconciler() {
  createResourceShortlistAssociationCacheReconciler(queryClient);
}
